import { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'next-i18next';

import { useCore } from '@phoenix/core/frontend/shared/feature/context/core.context';
import { HeadTitle } from '@phoenix/team-m/dashboard/frontend/shared/components/head-title';

export const PersonalSalutation: FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation();
  const { t: tShared } = useTranslation('shared');
  const { auth } = useCore();
  const salutation = t('dashboard_welcome_headline', { firstName: auth?.user?.given_name });
  const pageTitle = tShared('contentful_links_myStihlNavigation_dashboard_name');

  return (
    <div className="rounded-md bg-primary-white px-6 py-5 desktop:max-w-[400px]">
      <HeadTitle title={`${salutation} (${pageTitle})`} />
      <h1 id="page-title" className="!font-['STIHL-Contraface-Text'] stihl-text-h2-desktop" data-testid="personalSalutation">
        <span className="sr-only">{pageTitle}</span>
        {salutation}
      </h1>
      <p className="my-4 stihl-text-body-default-reg">{t('dashboard_welcome_subLine')}</p>
      {children}
    </div>
  );
};
